export function validateParty(adults: number, children: number): string {
  const errorMessage = 'Please have at least one person in your party.'

  function isValid() {
    return children !== 0 || adults !== 0
  }

  return !isValid() ? errorMessage : ''
}
